module.exports = __webpack_public_path__ + "static/flags/NP-f34c98bcc59fe463dd9d1c41aac58bb0.gif";